import { DateRange } from "@/types/date-range";
import { atom } from "recoil";

export const quoteAndOrderDurationState = atom<DateRange>({
  key: "quoteAndOrderDurationState",
  default: {
    startDate: undefined,
    endDate: undefined,
  },
});
